import { format } from 'date-fns';

export function formatDate(dateString: string): string {
  try {
    return format(new Date(dateString), 'd MMM yyyy');
  } catch {
    return dateString;
  }
}
